import React, { useEffect, useState } from "react";
import DandDAPI from "@dndUtilities/system_api";
import { isDataType } from "@dndModels/Types";
import { ModelBase } from "@models";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import DisplayObject from "@dndComponents/display/DisplayObject";
import { CharacterSpell, Spell } from "@dndModels";

import Grid from '@mui/material/Grid2';
import ViewSpell from "@dndComponents/display/ViewSpell";
import SpellDetails from "@dndComponents/display/SpellDetails";

const api = DandDAPI.getInstance();

// Extend the Window interface for TypeScript
declare global {
  interface Window {
    linkClicked?: (data_type: string, id: string) => void;
  }
}

export default function LinkModal() {
  const [modal_object, setModalObject] = useState<ModelBase | undefined>(undefined);

  useEffect(() => {
    window.linkClicked = (data_type: string, id: string) => {
      if (isDataType(data_type)) {
        api.getFullObject(data_type, id).then(res => {
          if (res) {
            setModalObject(res);
          }
        });
      }
    };

    // Cleanup on unmount
    return () => {
      delete window.linkClicked;
    };
  }, []); // Add dependencies if the function uses state/props

  const renderModalObject = () => {
    if (modal_object) {
      if (modal_object instanceof Spell) {
        const the_spell = modal_object;
        let show_ritual = true;
        if (the_spell) {
          return (
            <div style={{ padding: "4px", fontSize: "11px" }}>
              <Grid container spacing={0} direction="row" style={{ overflowX: "hidden" }}>
                <Grid size={6}>
                  <ViewSpell spell={the_spell}
                    show_level 
                    show_ritual={show_ritual}
                    fontSize={20}
                    fontWeight={"bold"}
                  />
                </Grid>
                <Grid size={12}>
                  { the_spell.level_and_school }
                </Grid>
                {/* <Grid
                  size={{
                    xs: 6
                  }}>
                  { renderLevelOptions() }
                </Grid> */}
                <Grid size={12}> 
                  {/* { !reloading &&
                    <CharacterEffects 
                      char={character}
                      char_interface={char_interface}
                      obj={obj}
                      action={action}
                      level={selected_level}
                      wide
                      casting_time={action.casting_time}
                      disabled={!enabled}
                      shared={shared}
                      show_extra_effects
                      onChange={() => {
                        character.subscription_holder.recalculate();
                      }}
                    />
                  } */}
                </Grid> 
                <Grid size={12}>
                  <SpellDetails spell={the_spell} />
                </Grid>
              </Grid>
            </div>
          );
        } else {
          return <></>
        }
      } else {
        return (
          <DisplayObject
            obj={modal_object}
          />
        );
      }
    }
    return null;
  }

  return (
    <ModalOrDrawer
      open={modal_object !== undefined}
      onClose={() => setModalObject(undefined)}
    >
      <>
        { renderModalObject() }
      </>
    </ModalOrDrawer>
  );
}